import {
  BaseNav,
  ChakraBreakpoints,
  FeatureFlagButton,
  RouteAuthenticationRequirement,
  SupportButton,
  useAuth,
  useNavItemStore
} from '@cks-internal/react-base';
import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, type BoxProps, HStack, Image } from '../ui/chakraPrimitives';
import { ApplicationRoutes } from '../../constants/appRoutes.ts';
import logo from '../../assets/logo-full.png';
import { CompassUser } from '../../globalTypes/user/compassUser.ts';
import { GoToJobSearch } from './GoToJobSearch.tsx';

type NarrowLayoutProps = {
  containerProps?: BoxProps;
};

const showSupportAndBetaButtons = false;

export const Layout = (props: NarrowLayoutProps) => {
  const routeNav = useNavItemStore((state) => {
    return { items: state.getDefault(), get: state.get };
  });

  const profileItems: BaseNav.NavItem = useMemo(() => {
    const subItems: BaseNav.NavItem[] = [
      routeNav.get(ApplicationRoutes.account.myProfile),
      routeNav.get(ApplicationRoutes.account.logout)
    ];
    return {
      text: 'Profile',
      subItems: subItems,
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      allowedRoles: []
    };
  }, []);

  const auth = useAuth<CompassUser>();

  return (
    <Box as='section' width='100vw' height='100vh' overflowY='auto' bg={'#fafafa'}>
      <BaseNav.Header
        menuMode={'hover'}
        avatarName={`${auth.user?.FirstName} ${auth.user?.LastName}`}
        navItems={routeNav.items}
        profileItems={profileItems}
        logo={
          <HStack>
            <Image width={'160px'} height={['41px']} src={logo} alt='logo' />
          </HStack>
        }>
        {auth.isAuthenticated && (
          <>
            <GoToJobSearch />
            {showSupportAndBetaButtons && (
              <>
                <SupportButton useDisplayMedia={true} />
                <FeatureFlagButton />
              </>
            )}
          </>
        )}
      </BaseNav.Header>
      <ChakraBreakpoints />
      <Box
        w={{ base: '100%', full: '90%' }}
        margin={'auto'}
        paddingLeft={'5px'}
        paddingRight={'5px'}
        paddingTop={'10px'}
        {...props.containerProps}>
        <Outlet />
      </Box>
    </Box>
  );
};
